// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinner_container__2ZXOl"};